





























import { SXQuestion, SXAnswer } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class WQuestionView extends BaseComponent {
	@Prop({ type: SXQuestion, required: true })
	question!: SXQuestion;
	@Prop()
	injectedAnswer: any;
	@Prop()
	injectedStats: any;
	@Prop({ type: Boolean, default: false })
	lock!: boolean;

	answer: any = null;

	get qData() {
		return this.ux_question_data(this.question);
	}
	get isValid() {
		return this.ux_answer_valid(this.question, this.answer);
	}
	get validityClass() {
		let isValid = this.lock || this.isValid;
		return { "bg-danger": !isValid, "bg-success": isValid };
	}
	get validityIconClass() {
		let isValid = this.lock || this.isValid;
		return { "fa-times-circle": !isValid, "fa-check-circle": isValid };
	}

	@Emit("question-answer-change")
	onTypeAnswerChange(answer: any) {
		this.answer = answer;
	}
	questionTypeComponent(question: SXQuestion) {
		return `w-qtype-${question.type}-view`;
	}
}
